'use strict';

import controller from './user_id.controller';

export default {
  template: '<div class="UserId"><h1>Your user ID is: {{::ctrl.userId}}</h1></div>',
  controllerAs: 'ctrl',
  controller: controller
};



// WEBPACK FOOTER //
// ./app/src/modules/user_id/user_id.component.js